<mat-checkbox
  [formControl]="checkboxControl"
  [indeterminate]="status?.hasSelectedChildren"
  (click)="$event.stopPropagation()"
></mat-checkbox>
